module.exports = __webpack_public_path__ + "img/icon_map_xmsh.17111f17.png";